<template>
  <div class="footer-copyright">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <p class="my-4">All site content, except where otherwise notes, is licensed under a Creative Commons Attribution 3.0 License.</p>
        </div>
        <div class="col-md-6">
          <p class="my-4">Copyright &copy; 2008-2016 Impact Journals, LLC. All rights reserved. Impact Journals is a trademark of Impact Journals, LLC.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'footer-copyright',
    data () {
      return {
      }
    }
  }
</script>
<style lang="scss">
  .footer-copyright {
    border-top: 1px solid $footer-bottom-border;
    min-height: 66px;
    background-color: $footer-copyright-background;
    font-family: 'Open Sans Condensed', sans-serif;
    font-size: 14px;
    line-height: 17px;
  }
</style>



// WEBPACK FOOTER //
// FooterCopyrightComponent.vue?0c58ef59